(() => {
  const SELECTORS = {
    overlay: '[data-techno-search-overlay]',
    open: '[data-techno-search-open]',
    close: '[data-techno-search-close]',
    input: '#TechnoSearchInput',
    panel: '.techno-search-overlay__panel',
    suggestion: '[data-techno-search-suggestion]',
  };

  const getFocusable = (container) => Array.from(
    container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
  ).filter((element) => !element.hidden && element.offsetParent !== null);

  const init = () => {
    const overlay = document.querySelector(SELECTORS.overlay);
    if (!overlay || overlay.dataset.initialized === 'true') return;
    overlay.dataset.initialized = 'true';

    const input = overlay.querySelector(SELECTORS.input);
    const panel = overlay.querySelector(SELECTORS.panel);
    let returnFocus = null;

    const open = (trigger) => {
      returnFocus = trigger || document.activeElement;
      const mobileMenu = document.querySelector('.agoga-mobile-menu:not([hidden])');
      mobileMenu?.querySelector('.agoga-mobile-menu__close')?.click();
      overlay.hidden = false;
      document.documentElement.classList.add('techno-search-is-open');
      requestAnimationFrame(() => {
        overlay.classList.add('is-open');
        input?.focus({ preventScroll: true });
        input?.select();
      });
    };

    const close = () => {
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('techno-search-is-open');
      window.setTimeout(() => {
        overlay.hidden = true;
        if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
      }, 220);
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest(SELECTORS.open);
      if (opener) {
        event.preventDefault();
        open(opener);
        return;
      }
      if (event.target.closest(SELECTORS.close)) {
        event.preventDefault();
        close();
      }
    });

    overlay.querySelectorAll(SELECTORS.suggestion).forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        input.value = button.dataset.technoSearchSuggestion || '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    });

    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab' || !panel) return;
      const focusable = getFocusable(panel);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.TechnoSearch = { open, close };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
